module.exports = __webpack_public_path__ + "static/media/open-enrollment.6612d01c.png";